import { store } from '@/stores'
import { SET_PAYMENT_INFO } from '@/action-types/payment'

export const setPaymentInfo = (jsonStr: any) => {  
  if (typeof(jsonStr) === 'string') {
    store.dispatch({
      type: SET_PAYMENT_INFO,
      payload: JSON.parse(jsonStr)
    })
  } else {
    store.dispatch({
      type: SET_PAYMENT_INFO,
      payload: jsonStr
    })
  }
}